export default {
    getIsLogin: (state) => state.isLogin,
    getConfigData: (state) => state.configData,
    getBaseQuotes: (state) => state.baseQuotes,
    getUpdateQuotes: (state) => state.updateQuotes,
    getInnerHeight: (state) => state.innerHeight,
    getSymbolList: (state) => state.symbolList,
    getIsShowBalance: (state) => state.showBalance,
    getInvestData: (state) => state.investData,
    getUserInfo: (state) => state.userInfo,
    getLanguage: (state) => state.language,
    getRateList: (state) => state.rateList,
    getCurrentRate: (state) => state.currentRate,
    getAuthInfo: (state) => state.authInfo,
    getThemeType: (state) => state.themeType,
    getLanguages: (state) => state.languages,
    getIsApp: (state) => state.isApp,
    getLastPrice:(state) => state.lastPrice
}